// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getById, getDataView } from "@insite/client-framework/Store/Data/DataState";
import { StoreListsDataView } from "@store/Framework/Store/Data/StoreLists/StoreListsState";
import { StoreListModel } from "@store/Framework/Types/ApiModels";
import { GetStoreListsApiParameter } from "@store/Services/StoreListService";

export function getStoreListsDataView(state: ApplicationState, parameter: GetStoreListsApiParameter | undefined) {
    return getDataView<StoreListModel, StoreListsDataView>(state.store.data.storeLists, parameter);
}

export function getStoreListState(state: ApplicationState, storeListId: string | undefined) {
    return getById(state.store.data.storeLists, storeListId);
}
